import React from 'react';

const testimonials = [
  {
    name: 'Alexandre D.',
    role: 'Fondateur, Agence digitale',
    quote: "J'ai signé mon plus gros contrat 3 semaines après. Mais le vrai gain ? L'énergie et la clarté que j'ai retrouvées.",
    result: '+10x CA'
  },
  {
    name: 'Thomas M.',
    role: 'CEO, SaaS B2B',
    quote: "En 6 jours, j'ai construit plus de relations business qu'en 2 ans de networking classique. Des frères pour la vie.",
    result: '3 deals signés'
  },
  {
    name: 'Julien R.',
    role: 'E-commerce, 8 figures',
    quote: "Je suis reparti avec un plan d'action béton et -7kg. Mon équipe m'a dit que j'étais redevenu le leader qu'ils attendaient.",
    result: '-7kg, +clarté'
  }
];

const TestimonialsSection = () => {
  return (
    <div className="bg-black py-20 px-6 border-t border-white/5" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#D4A574] text-[10px] tracking-[0.4em] mb-4">TÉMOIGNAGES</p>
          <h2 className="font-italiana text-3xl md:text-4xl text-white tracking-[0.08em] uppercase">
            Ils l'ont <span className="text-[#D4A574]">vécu</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 hover:border-[#D4A574]/30 transition-colors"
            >
              <div className="flex items-center gap-2 mb-4">
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className="w-4 h-4 text-[#D4A574]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              
              <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>
              
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white font-medium">{testimonial.name}</p>
                  <p className="text-white/50 text-xs">{testimonial.role}</p>
                </div>
                <div className="bg-[#D4A574]/20 px-3 py-1 rounded-full">
                  <p className="text-[#D4A574] text-xs font-medium">{testimonial.result}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-white/30 text-xs tracking-wider">
            Résultats réels de participants VIVANT
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
